module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-280.01f7425a.jpg";